import { Routes } from '@angular/router';
import { apiSchemaResolver } from './resolvers/api-schema.resolver';

export const routes: Routes = [
	{
		path: 'schemas',
		data: { breadcrumb: 'API_SCHEMAS.TITLES.BREADCRUMB' },
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./components/api-schema-list/api-schema-list.component').then(
						(component) => component.ApiSchemaListComponent
					)
			},
			{
				path: ':schemaId',
				resolve: { schema: apiSchemaResolver },
				data: {
					breadcrumb: ({ schema }) => schema.name
				},
				children: [
					{
						path: '',
						loadComponent: () =>
							import('./components/api-schema/api-schema.component').then(
								(component) => component.ApiSchemaComponent
							)
					},
					{
						path: 'map',
						loadComponent: () =>
							import(
								'./components/api-schema-map/api-schema-map.component'
							).then((component) => component.ApiSchemaMapComponent)
					}
				]
			},
			{
				path: 'map',
				loadComponent: () =>
					import('./components/api-schema-map/api-schema-map.component').then(
						(component) => component.ApiSchemaMapComponent
					)
			}
		]
	}
];
